import * as project from '../views/projects';
import * as toast from '../components/toast';
import * as role from '../views/roles';
import * as group from '../views/groups';
import * as user from '../views/users';

const modules = {
	project,
	toast,
	role,
	group,
	user,
};

export default modules;
